import { Designer } from "@brg/api";
import { IThemeItem } from "shared/constants/ILMS";

// Интерфейс для группы
export interface IGroup {
  id: string;
  name: Array<{ lang: string; name: string }>;
}

// Интерфейс для слота расписания
export interface IScheduleSlot {
  id: string;
  date: Date | null;
  start: string; // ISO date string или время в формате HH:mm
  end: string; // ISO date string или время в формате HH:mm
  groupIds: string[];
  themeId?: string; // ID темы или 'consultation' для консультации
  location: string;
  isSelected?: boolean;
  classType?: LMSLessonClassTypeModel;
  type?: number;
  title?: Array<{ lang: string; name: string }>;
  status?: number;
  teacherId?: string;
  consultation?: IConsultationSettings;
}

// Типы занятий
export enum LMSLessonClassTypeModel {
  Ordinal = 0,
  Workshop = 1,
  Lecture = 2,
  Seminar = 3,
  Consultation = 4,
}

// Интерфейс для данных занятия
export interface ILessonData {
  courseStartDate: Date | null;
  courseEndDate: Date | null;
  selectedDays: number[]; // массив дней недели (0-6, воскресенье-суббота)
  start: string;
  end: string;
  zoomLink: string;
  selectedGroups: string[]; // массив ID выбранных групп
  selectedThemeId?: string; // ID выбранной темы
  selectedLessonType: LMSLessonClassTypeModel; // тип занятия
  consultation?: IConsultationSettings;
  consultationOverridesByDay?: Record<number, {
    start?: string;
    end?: string;
    location?: string;
    teacherId?: string;
    isInvitedTeacher?: boolean;
  }>;
}

// Данные формы внутри модалки добавления занятий
export interface ILessonModalData {
  selectedDays: number[];
  start: string;
  end: string;
  zoomLink: string;
  selectedGroups: string[];
  selectedLessonType: LMSLessonClassTypeModel;
}

export interface IConsultationLessonData {
  disciplineId?: string;
  courseStartDate: Date | null;
  courseEndDate: Date | null;
  selectedDays: number[];
  start: string;
  end: string;
  capacity: string;
  timePerPerson: number | null;
  format: 'online' | 'offline';
  location: string;
  registrationDaysBefore: number | null;
  teacherId: string;
  isInvitedTeacher: boolean;
  selectedGroups: string[];
  selectedThemeId?: string;
  daySchedules?: Record<number, {
    start: string;
    end: string;
    location: string;
    teacherId: string;
    isInvitedTeacher: boolean;
  }>;
}

export interface IConsultationSettings {
  disciplineId?: string;
  capacity?: number;
  timePerPerson?: number;
  format: 'online' | 'offline';
  registrationDaysBefore?: number;
  teacherId?: string;
  isInvitedTeacher: boolean;
}

export interface IRegularDaySchedule {
  start: string;
  end: string;
  format: 'online' | 'offline';
  location: string;
  teacherId: string;
  isInvitedTeacher: boolean;
  selectedGroups: string[];
}

export interface IRegularLessonData {
  courseStartDate: Date | null;
  courseEndDate: Date | null;
  lessonType: LMSLessonClassTypeModel;
  daySchedules: Record<number, IRegularDaySchedule>;
  selectedThemeId?: string;
}

export interface LessonsEditorProps {
  themeInfos?: IThemeItem[];
  projectId?: string;
  teamId?: string;
  onSaveLessonsRef?: React.MutableRefObject<(() => Promise<boolean>) | null>;
  isThemeSaveRequired?: boolean;
  onSpecialThemeSelected?: (themeId: 'consultation' | 'preview') => void;
  inlineLessonForm?: boolean;
  moduleTeachers?: Designer<'Local'>[];
  disciplineOptions?: Array<{ value: string; label: string }>;
  selectedDisciplineId?: string;
  isConsultationSignupLimited?: boolean;
  consultationSignupLimitDays?: number | null;
  onConsultationSignupLimitChange?: (enabled: boolean) => void;
  onConsultationSignupLimitDaysChange?: (days: number | null) => void;
}import { Designer } from "@brg/api";
import { IThemeItem } from "shared/constants/ILMS";

// Интерфейс для группы
export interface IGroup {
  id: string;
  name: Array<{ lang: string; name: string }>;
}

// Интерфейс для слота расписания
export interface IScheduleSlot {
  id: string;
  date: Date | null;
  start: string; // ISO date string или время в формате HH:mm
  end: string; // ISO date string или время в формате HH:mm
  groupIds: string[];
  themeId?: string; // ID темы или 'consultation' для консультации
  location: string;
  isSelected?: boolean;
  classType?: LMSLessonClassTypeModel;
  type?: number;
  title?: Array<{ lang: string; name: string }>;
  status?: number;
  teacherId?: string;
  consultation?: IConsultationSettings;
}

// Типы занятий
export enum LMSLessonClassTypeModel {
  Ordinal = 0,
  Workshop = 1,
  Lecture = 2,
  Seminar = 3,
  Consultation = 4,
}

// Интерфейс для данных занятия
export interface ILessonData {
  courseStartDate: Date | null;
  courseEndDate: Date | null;
  selectedDays: number[]; // массив дней недели (0-6, воскресенье-суббота)
  start: string;
  end: string;
  zoomLink: string;
  selectedGroups: string[]; // массив ID выбранных групп
  selectedThemeId?: string; // ID выбранной темы
  selectedLessonType: LMSLessonClassTypeModel; // тип занятия
  consultation?: IConsultationSettings;
  consultationOverridesByDay?: Record<number, {
    start?: string;
    end?: string;
    location?: string;
    teacherId?: string;
    isInvitedTeacher?: boolean;
  }>;
}

// Данные формы внутри модалки добавления занятий
export interface ILessonModalData {
  selectedDays: number[];
  start: string;
  end: string;
  zoomLink: string;
  selectedGroups: string[];
  selectedLessonType: LMSLessonClassTypeModel;
}

export interface IConsultationLessonData {
  disciplineId?: string;
  courseStartDate: Date | null;
  courseEndDate: Date | null;
  selectedDays: number[];
  start: string;
  end: string;
  capacity: string;
  timePerPerson: number | null;
  format: 'online' | 'offline';
  location: string;
  registrationDaysBefore: number | null;
  teacherId: string;
  isInvitedTeacher: boolean;
  selectedGroups: string[];
  selectedThemeId?: string;
  daySchedules?: Record<number, {
    start: string;
    end: string;
    location: string;
    teacherId: string;
    isInvitedTeacher: boolean;
  }>;
}

export interface IConsultationSettings {
  disciplineId?: string;
  capacity?: number;
  timePerPerson?: number;
  format: 'online' | 'offline';
  registrationDaysBefore?: number;
  teacherId?: string;
  isInvitedTeacher: boolean;
}

export interface IRegularDaySchedule {
  start: string;
  end: string;
  format: 'online' | 'offline';
  location: string;
  teacherId: string;
  isInvitedTeacher: boolean;
  selectedGroups: string[];
}

export interface IRegularLessonData {
  courseStartDate: Date | null;
  courseEndDate: Date | null;
  lessonType: LMSLessonClassTypeModel;
  daySchedules: Record<number, IRegularDaySchedule>;
  selectedThemeId?: string;
}

export interface LessonsEditorProps {
  themeInfos?: IThemeItem[];
  projectId?: string;
  teamId?: string;
  onSaveLessonsRef?: React.MutableRefObject<(() => Promise<boolean>) | null>;
  isThemeSaveRequired?: boolean;
  onSpecialThemeSelected?: (themeId: 'consultation' | 'preview') => void;
  inlineLessonForm?: boolean;
  moduleTeachers?: Designer<'Local'>[];
  disciplineOptions?: Array<{ value: string; label: string }>;
  selectedDisciplineId?: string;
  isConsultationSignupLimited?: boolean;
  consultationSignupLimitDays?: number | null;
  onConsultationSignupLimitChange?: (enabled: boolean) => void;
  onConsultationSignupLimitDaysChange?: (days: number | null) => void;
}